window.Onboarding = function(containerId, lang, originalLang)
{
    this.defaultUiLang          = 'en';
    this.selector               = containerId == undefined ? 'onboardingTrial' : containerId;
    this.onboarding             = $('#'+this.selector);
    this.form                   = this.onboarding.children('form');
    this.currentStep            = 0;
    this.stepsNumber            = 0;
    this.validationRoute        = '/onboarding/trial/';
    this.activationRoute           = '/onboarding/trial/activation';
    this.autocompleteCountry    = null;

    this.sel = {
        team     : $('[name=staff_team]'),
        position : $('[name=staff_position]'),
    };

    this.setSetupLang(lang, originalLang);
    this.defineCountry(originalLang);
    this.defineCountryCode(originalLang);

    this.init();
};

Onboarding.prototype = {

    init: function(){
        this.initButtons();
        this.initTriggers();
        this.countSteps();
        this.setCurrentStep(1);
        this.initSteps();
        this.initAlgolia();

        MyFacture.initCsrfToken();
        MyFacture.customForm();
    },

    initAlgolia: function(){

        var self = this;

        $.ajax({
            type: "GET",
            url: '/algolia/config/places',
            success: function(algolia){

                var options = {
                    container: document.querySelector('#country-input'),
                    type: 'country',
                    language: self.setupLang,
                    templates: {
                        suggestion: function(suggestion) {
                            return suggestion.highlight.name;
                        }
                    }
                };

                self.autocompleteCountry = places(_.extend(options, algolia.config));
                self.autocompleteCountry.setVal(self.country);

                self.autocompleteCountry.on('change', function resultSelected(e) {
                    self.setSetupLang(e.suggestion.countryCode);
                    self.setCountryCode(e.suggestion.countryCode);
                });
            },
            dataType: 'json'
        });
    },

    initButtons: function(){
        var onboarding = this;

        this.onboarding.find('.btn-validateStep').each(function(){

            var step = $(this).parents('.step').attr('step-id');

            // initial check button state
            onboarding.checkButtonState(step);
        });

        // bind step's validation on button click
        this.onboarding.find('.btn-validateStep').click(function(e){
            e.preventDefault();
            onboarding.validateStep(onboarding.getCurrentStep());
        });

        this.onboarding.find('#prev-page-container #prev-page-btn').click(function(){
            onboarding.goToStep(onboarding.currentStep-1);
        })

        this.onboarding.find('#prev-page-container .btn-change-language').click(function(){
            LocalizationHelpers.changeLanguage($(this).data('language'));
        })


    },

    defineCountry: function(lang){
        var countries = {
            fr: window.i18n.gettext('France'),
            en: window.i18n.gettext('Royaume-Uni'),
            es: window.i18n.gettext('Espagne'),
            de: window.i18n.gettext('Allemagne')
        };
        this.country = countries[lang];
    },

    defineCountryCode: function(lang){
        var country_codes = {
            fr: 'fr',
            en: 'gb',
            es: 'es',
            de: 'de'
        };
        this.setCountryCode(country_codes[lang], true);
    },

    setCountryCode: function(countrycode, init){
        $('#corporation_country').val(countrycode);

        if(init !==undefined && init)
            this.onboarding.find('.defaultCountryCode, .e164Country').val(countrycode);
    },

    initTriggers: function(){
        var onboarding = this;

        this.onboarding.find('input, select').on('change', function(){
            var step = $(this).parents('.step').attr('step-id');

            onboarding.checkButtonState(step);
        });

        this.initPositionSelTrigger();
    },

    initPositionSelTrigger: function(){
        var onboarding = this;

        onboarding.sel.team.on('change', function(){

            var teamVal         = onboarding.sel.team.val();
            var optgroupCatalog = $('[name=staff_position_catalog]').find('optgroup');
            var optgroup        = onboarding.sel.position.find('optgroup');

            if(teamVal == optgroup.filter(':visible').val || !teamVal)
                return;

            onboarding.sel.position.parents('.form-group').toggleClass('hide', !teamVal);

            optgroup.remove();
            optgroupCatalog.filter('[value=' + teamVal + ']').clone().appendTo(onboarding.sel.position);
        })
    },

    initSteps: function() {
        for (var i = 0; i < this.stepsNumber; i++) {
            if (i == 0)
                $(".step-indicator-container ul").append("<li class='step-indicator active'></li>");
            else
                $(".step-indicator-container ul").append("<li class='step-indicator'></li>");
        }

        $(".step-indicator-container .currentStep").text(this.getCurrentStep());
        $(".step-indicator-container .nbStep").text(this.stepsNumber);
    },

    countSteps: function () {
        this.stepsNumber = this.onboarding.find(".step").length;
    },
    
    checkButtonState: function(step){
        if (step == undefined)
            step = this.getCurrentStep();


        var stepBlock   = this.onboarding.find('[step-id='+step+']');
        var button      = stepBlock.find('.btn-validateStep');
        var inputs      = stepBlock.find('input, select');

        if (inputs.length == 0)
            return true;

        var isValid = true;
        

        inputs.each(function(){
            if(!isValid) { return; }
            switch ($(this).prop('tagName').toLowerCase()){
                case 'input':
                    // If checkbox
                    if ($(this).attr('type') == "checkbox" && !!$('[name='+$(this).attr('name')+']:checked').length)        return;
                    if ($(this).attr('type') == 'checkbox' && $(this).is(':required'))
                        isValid = $(this).is(':checked');    
                    else if ($(this).attr('type') == 'radio' )
                        isValid = $('[name=' + $(this).attr('name') + ']:checked').length
                    else
                        isValid = !!$(this).val().length;
                    break;
                case 'select':
                    var value = $(this).val();
                    isValid = value && !!value.length;
                    break;
            }
        });
        this.switchButtonState(button, isValid);  
    },

    switchButtonState: function(button, toEnabled){
        if (toEnabled)
            button.removeAttr('disabled');
        else
            button.attr('disabled', 'disabled');
    },

    setSetupLang: function(lang, backupLang){
        this.setupLang = lang;

        let select = $("select[name='staff_uilang']");
        // option for lang doesn't exist
        if (!select.children(`[value="${lang}"]`).length) {
            return this.setSetupLang(backupLang ?? this.defaultUiLang);
        }
        // affect lang to select
        select.val(lang);
    },

    getCurrentStep: function(){
        return this.currentStep;
    },
    
    setCurrentStep: function(step){
        if(step == undefined)
            step = this.getCurrentStep();

        this.checkButtonState(step);
        this.currentStep = step;
    },
    
    validateStep: function(step){
        if(step == undefined)
            step = this.getCurrentStep();
        this.sendRequest(step);
    },
    
    sendRequest: function(step, isFinal){

        var self = this;

        let nextStep = function() {
            $.ajax({
                url: self.validationRoute + (!(isFinal !== undefined && isFinal) ? step : 'final') + '?lang=' + self.setupLang ,
                type    : 'POST',
                data    : self.form.serialize(),
                dataType: 'json',
                async   : false,
                success : function(response){
                    data = response;
                    self.processReturn(data);
                }, error: function (response) {
                    if (response.status == 422) { // Unprocessable Entity
                        // Return response (back-side validation return a json with this http code when error)
                        data = response.responseJSON;
                        self.processReturn(data);
                    } else if (response.status == 500) {
                        Push.error(response.responseJSON.error.message)
                    }
                }
            });
        };
        self.captcha(nextStep);
    },

    captcha : function (cb) {

        if (window.App.recaptchav3SiteKey != undefined && typeof grecaptcha !== 'undefined') {

            let self = this;

            grecaptcha.ready(function () {
                grecaptcha.execute(window.App.recaptchav3SiteKey, { action: 'onboardingTrialValidate' })
                .then(token => {

                    // Google reCaptcha v3 input hidden
                    if (!$('#g-recaptcha-response').length) {
                        self.form.prepend('<input type="hidden" id="g-recaptcha-response" name="g-recaptcha-response">');
                    }
                    $('#g-recaptcha-response').val(token);

                    cb();
                });
            });
        } else {
            cb();
        }
    },

    processReturn : function(data){
        var self = this;
        var formIsOk = MyForm.processJson(data);
        
        if (!formIsOk)
            return;

        if(!data.hasNextStep) {

            if (data.onboardingCanBeProcessed) {
                $("#onboardingTrial").fadeOut("slow", function () {
                    $("body").addClass("cprogress");
                    
                    $("#final-message").fadeIn("slow", function(){
                        self.validateStep('final');
                    });
                });
            }
            else
                self.final(data);
        } 
        else {
            this.goToStep(this.getCurrentStep()+1);
        }
    },
    
    goToStep : function (step) {
        if (step == 0)
            return false;

        var self = this;

        if(step > 1)
            $("#prev-page-btn").show();
        else
            $("#prev-page-btn").hide();

        $(".step.active").fadeOut("slow", function () {
            $(this).removeClass("active");
            self.setCurrentStep(step);

            $('.step[step-id=' + step + ']').fadeIn("slow");
            $('.step[step-id=' + step + ']').addClass("active");
            $(".step-indicator-container .currentStep").text(step);
            $(".step-indicator-container .step-indicator").removeClass("active");
            $(".step-indicator-container .step-indicator").eq(step-1).addClass("active");
        })
    },

    final: function (data) {
        // Deal with onboarding status
        switch (data.onboarding.status) {
            case 'warning':
            case 'error':
                // - print message
                $("body").removeClass("cprogress");
                $("#final-message").fadeOut("slow", function(){

                    $("#final-message").prepend("<img width='520' src='../ressources/public/img/onboarding/Sellsy_produit_onboarding3.png'/>");

                    var title = '';
                    var msg   = '';

                    if (data.onboarding.status == 'warning') {
                        title = Loc.g("Votre demande est envoyée à notre équipe commerciale");
                        msg   = Loc.g("Nous avons bien reçu votre demande, un commercial vous recontactera dans les plus brefs délais.");
                    } else {
                        title = Loc.g("Une erreur est survenue lors de la création de votre compte");
                        msg   = Loc.g("Notre équipe est prévenue de ce problème. Nous vous invitons à relancer la création de votre compte d’ici quelques minutes.");
                        msg   += '<br/>';
                        msg   += Loc.g("Si le problème persiste, vous pouvez nous contacter sur l’adresse email : contact@sellsy.com");
                    }

                    $("#final-message h2").text(title);
                    $("#final-message p").html(msg);
                    $("#final-message").append("<a href='https://go.sellsy.com/' class='btn btn-primary mt-5'>"+Loc.g("Retourner sur le site")+"</a>");
                    $("#final-message").fadeIn("slow");
                });

                MyFacture.stopWait()

                break;
            
            case 'pending':
                var self = this;
                window.SellsyJS.WebServiceCaller.get(this.activationRoute, {}, (response) => {
                    if (undefined !== response.status && response.status == 'success') {
                        data.onboarding.status = response.status;
                        self.final(data);
                    } else {
                        setTimeout(function() {
                            self.final(data);
                        }, 1000);
                    }
                })
                break;

            case 'success':
                // - redirect to page
                Utils.relocate(data.onboarding.autolog);
                break;
        }
    },
};
